import { render } from "./SubCompanies.vue?vue&type=template&id=1f389378"
import script from "./SubCompanies.vue?vue&type=script&lang=ts"
export * from "./SubCompanies.vue?vue&type=script&lang=ts"
script.render = render

export default script